module.exports = __webpack_public_path__ + "img/Mantraz-logo.7fcd02a6.svg";